import { Link } from "react-router-dom";

import nlen from "../assets/Nlen.svg";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phonee from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";

import Newsletter from "./Newsletter";

const Footer = () => {
  return (
    <div className="bg-[#131519] text-white">
      {/* Footer Section */}
      <footer className="px-4 sm:px-6 lg:px-12 py-4 sm:py-6 lg:py-12">
        {/* Newsletter Section */}
        <div className="w-full sm:px-2 lg:px-4 sm:py-2 lg:py-4 flex flex-col gap-4 md:gap-8 lg:gap-12">
          {/* Top newsletter */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
            {/* Left Side */}
            <div className="flex items-start md:items-center gap-4 md:gap-6">
              <img
                src={news}
                alt="newsletter"
                className="w-12 h-12 md:w-[80px] md:h-[80px]"
              />
              <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                Join our newsletter to <br className="hidden md:block" />
                keep up to date with us!
              </h2>
            </div>

            {/* newsletter */}
            <Newsletter />
          </div>

          {/* Divider */}
          <div className="border-t border-gray-700 w-full" />

          {/* Main Footer Content */}
          <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
            {/* Company Info */}
            <div className="w-full lg:w-[30%]">
              <a href="/" aria-label="Lentera Home">
                <img src={nlen} alt="Lentera logo" className="mb-6" />
              </a>
              <p className="text-[#d4d4d4] leading-relaxed">
                We are highly experienced in offering software development,
                mobile application development, software consulting and project
                management delivery.
              </p>
              {/* Social Icons */}
              <div className="flex gap-4 mt-6 flex-wrap">
                <a
                  href="https://www.instagram.com/lenteratechnologies/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={inst} alt="Instagram" className="w-8 h-8" />
                </a>
                <a
                  href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={face} alt="Facebook" className="w-8 h-8" />
                </a>
                <a
                  href="https://www.youtube.com/@lenteratechnologies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={you} alt="YouTube" className="w-8 h-8" />
                </a>
                <a
                  href="https://www.linkedin.com/company/lenteratech/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                </a>
                <a
                  href="https://x.com/lenteratechnol1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twi} alt="X" className="w-8 h-8" />
                </a>
              </div>
            </div>

            {/* Services */}
            <div className="w-full sm:w-[45%] md:w-auto">
              <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">
                OUR SERVICES
              </h4>
              <ul className="space-y-2 text-[#d4d4d4]">
                <li>
                  <Link
                    to="/services/ai-services/"
                    className="hover:text-white"
                  >
                    AI services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/web-development/"
                    className="hover:text-white"
                  >
                    Web development
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/mobile-app-development/"
                    className="hover:text-white"
                  >
                    Mobile app development
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/software-consulting/"
                    className="hover:text-white"
                  >
                    Software consulting
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/custom-development/"
                    className="hover:text-white"
                  >
                    Custom consulting
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/third-party-integration/"
                    className="hover:text-white"
                  >
                    Third party integration
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/enterprise-application/"
                    className="hover:text-white"
                  >
                    Enterprise Application
                  </Link>
                </li>
              </ul>
            </div>

            {/* Insights */}
            <div className="w-full sm:w-[45%] md:w-auto">
              <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">
                INSIGHTS
              </h4>
              <ul className="space-y-2 text-[#d4d4d4]">
                <li>
                  <Link to="/blogs" className="hover:text-white">
                    Blog
                  </Link>
                </li>
                <li>
                  <a
                    href="/company/careers/"
                    className="hover:text-white"
                  >
                    Careers
                  </a>
                </li>
                {/* <li>
                  <Link to="/blogs" className="hover:text-white">
                    News
                  </Link>
                </li> */}
              </ul>
            </div>

            {/* Contact */}
            <div className="w-full md:w-auto">
              <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">
                CONTACT US
              </h4>
              <div className="flex items-start gap-3 mb-3">
                <img src={phonee} alt="phone" className="w-9 h-9 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Phone number</p>
                  <a
                    href="tel:+914448563345"
                    className="text-white font-medium text-sm hover:underline"
                  >
                    +91-44-4856-3345
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3 mb-3">
                <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Email address</p>
                  <a
                    href="mailto:info@lenteratech.com"
                    className="text-white font-medium text-sm hover:underline"
                  >
                    info@lenteratech.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Location</p>
                  <a
                    href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-medium text-sm hover:underline block"
                  >
                    G1, Plot No, 824 and 826, 3rd
                    <br />
                    Main Rd, Ram Nagar South,
                    <br />
                    Madipakkam, Chennai,
                    <br />
                    Tamil Nadu 600091
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Bottom Section */}
      <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
        <p>© 2026 Lentera Technologies Pvt Ltd. All rights reserved.</p>
        <div className="flex flex-wrap gap-4 justify-center md:justify-end">
          <a href="/terms-condition/" className="hover:underline">
            Terms and conditions
          </a>
          <a href="/privacy-policy/" className="hover:underline">
            Privacy Policy
          </a>
          <a href="/cookie-policy/" className="hover:underline">
            Cookies Policy
          </a>
          <a href="/copyright-information/" className="hover:underline">
            Copyright information
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
